export default {
    'all': 'All',
    'archive': 'Archive',
    'actions': 'Actions',
    'download': 'Download',
    'pleaseSelect': 'Please select',
    'country': 'Country',
    'province': 'Province',
    'district': 'District',
    'area': 'Area',
    'records': 'records',
    'found': 'Found',
    'document': 'Document',
    'offerDetail':'Offer Detail',
    'percent': 'Percent',
    'print':'Print',
    'printing':'Printing...',
    'loan':'Loan',
    'noOfBathrooms': 'No of Bathrooms',
    'noOfTotalrooms': 'No of total rooms',
    'feature': 'Featured',
    'remove': 'Remove',
    'advanceFilter': 'Advance Filter',
    'allViewStations':'All view stations',
    'from': 'From',
    'insert': 'Insert',
    'to': 'To',
    'id':'ID',
    'tax': 'Tax',
    'back': 'Back',
    'reset': 'Reset',
    'name': 'Name',
    'price': 'Price',
    'address': 'Address',
    'batch': 'Batch',
    'date':'Date',
    'findLocation':'Find location',
    'saleOrRent' : 'Sale / Rent',
    'sureToDelete': 'Sure to delete?',
    'yes': 'Yes',
    'no': 'No',
    'max': 'Max',
    'thisFieldIsRequired': 'This field is required',
    'sureToDeleteProperty': 'Sure to delete?',
    'mortgageCancelationDate':'Mortgage Cancellation Date',
    'mortgageCancelationDateText':'Mortgage Cancellation Date - Text',
    'unitcode': 'Unit Code',
    'commission.title.property': 'Property',
    'commission.title.price': 'Price',
    'commission.title.type': 'Type',
    'commission.title.note': 'Note',
    'commission.title.percentage': 'Percentage',
    'commission.title.fixed': 'Fixed',
    'commission.title.total': 'Total',
    'commission.title.dueDate': 'Due Date',
    'commission.title.export': 'Export',
    'commission.title.contractDate': 'Contract Date',
    'commission.header.commissionReport': 'Commission Report',
    'commission.header.dateFrom': 'Date From',
    'commission.header.dateTo': 'Date To',
    'commission.table.export.excel': 'Excel',
    'commission.table.export.pdf': 'Pdf',
    'project.modalConfirm.deleteProjectTitle': 'Delete Project',
    'project.modalConfirm.deleteProjectMessage': 'Confirm to delete this project',
    'project.modalConfirm.deleteProjectUnitTypeTitle': 'Delete Project Unit',
    'project.modalConfirm.deletProjectUnitTypeMessage': 'Confirm to delete this project unit',
    'projectList.title.project': 'Project',
    'projectList.title.projectName': 'Project Name',
    'projectList.title.location': 'Location',
    'projectList.title.projectType': 'Project Type',
    'projectList.title.unitsV': 'Units',
    'projectList.title.lastUpdate': 'Last Update',
    'projectList.title.search': 'Search',
    'projectList.button.addProject': 'Add New Project',
    'projectList.button.updateProject': 'Update Project',
    'projectList.validate.greaterThanFrom' : 'to must greater than from',
    'projectDetail.portal': 'Portal',
    'projectDetail.onWeb': 'On web',
    'projectDetail.notOnWeb': 'Not on web',
    'projectDetail.viewOnWeb': 'View on web',
    'projectDetail.button.selectAll': 'Select All',
    'projectDetail.button.selectNone': 'Select None',
    'projectDetail.button.invertSelect': 'Invert Select',
    'projectDetail.button.batch': 'Batch',
    'projectDetail.textbox.projectName': 'Project Name',
    'projectDetail.dropdown.projectId': 'Project ID',
    'projectDetail.dropdown.projectType': 'Project Type',
    'projectDetail.autocomeplete.developer': 'Developer',
    'projectDetail.textbox.totalUnit': 'Total Unit',
    'projectDetail.dropdown.location': 'Location',
    'projectDetail.dropdown.area': 'Area',
    'projectDetail.textarea.address': 'Address',
    'projectDetail.textbox.yearBuilt': 'Years Built',
    'projectDetail.textbox.yearComplete': 'Year Complete',
    'projectDetail.dropdown.status': 'Status',
    'projectDetail.textbox.landSize': 'Land Size',
    'projectDetail.textbox.rai': 'Rai',
    'projectDetail.textbox.ngan': 'Ngan',
    'projectDetail.textbox.wa': 'Wa',
    'projectDetail.textbox.sqm': 'Sq.m',
    'projectDetail.textbox.sqw': 'Sq.w',
    'projectDetail.gallery': 'Gallery',
    'projectDetail.floorPlan': 'Floor Plan',
    'projectDetail.button.upload': 'Upload',
    'projectDetail.button.delete': 'Delete',
    'projectDetail.textarea.remark': 'Remark',
    'projectDetail.textbox.unitType': 'Unit Type',
    'projectDetail.textbox.unitName': 'Unit Name',
    'projectDetail.advertisementVdo': 'Advertisement VDO',
    'projectDetail.textbox.code': 'Code',
    'projectDetail.textbox.size': 'Size',
    'projectDetail.button.addUnitType': 'Add Unit Type',
    'projectDetail.tab.unitDetail': 'Unit Detail',
    'projectDetail.tab.matrixView': 'Matrix View',
    'projectDetail.tab.sales': 'Sales',
    'projectDetail.tab.construction': 'Construction',
    'projectDetail.button.updateProjectUnits': 'Update Project Units',
    'projectDetail.button.showEnquiry': 'Show Enquiries',
    'projectDetail.button.showUnits': 'Show Units',
    'projectDetail.button.projectReports': 'Project Reports',
    'projectDetail.button.unitList': 'Unit List',
    'projectDetail.button.addEnquiry': 'Add Enquiry',
    'projectDetail.button.addUnits': 'Add Units',
    'projectDetail.button.deleteProject': 'Delete Project',
    'projectDetail.matrix.quickSearch': 'Quick Search',
    'projectDetail.matrix.all': 'All',
    'projectDetail.matrix.unitNumber': 'Unit Number',
    'projectDetail.matrix.unitNumber2': 'Unit Number',
    'projectDetail.matrix.unitType': 'Unit Type',
    'projectDetail.matrix.selectUnitType': 'Select Unit Type',
    'projectDetail.matrix.price': 'Price',
    'projectDetail.matrix.lowestPrice': 'Minimum Price',
    'projectDetail.matrix.saleState': 'Sale State',
    'projectDetail.matrix.selectSaleState': 'Select State',
    'projectDetail.matrix.saleAgent': 'Sale Person',
    'projectDetail.matrix.selectSaleAgent': 'Select Sale Person',
    'projectDetail.matrix.saleRepresentative': 'Sale Representative',
    'projectDetail.matrix.defect': 'Defect',
    'projectDetail.matrix.selectDefect': 'Select Defect',
    'projectDetail.matrix.percentComplete': 'Percent Complete',
    'projectDetail.matrix.markUpPrice': 'Mark Up Price (%)',
    'projectDetail.matrix.markDownPrice': 'Mark Down Price (%)',
    'projectDetail.matrix.markUpMinPrice': 'Mark Up Minimum Price (%)',
    'projectDetail.matrix.markDownMinPrice': 'Mark Down Minimum Price (%)',
    'projectDetail.matrix.batch': 'Batch',
    'projectDetail.matrix.useAsterisk': 'Use Asterisk(*) for any character',
    'projectDetail.matrix.markUnit': 'Mark Unit',
    'projectDetail.matrix.markPrice': 'Price',
    'projectDetail.matrix.markPercent': 'Percent(%)',
    'projectDetail.matrix.changeSaleState': 'Change Status',
    'projectDetail.matrix.changeSaleRepresentative': 'Change Sales representative',
    'projectDetail.matrix.assignToAgent': 'Assign to Agent',
    'projectDetail.matrix.selectState': 'Select State',
    'projectDetail.matrix.selectSalesRepresentative': 'Select Sales representative',
    'projectDetail.matrix.selectAgent': 'Select Agent',
    'projectDetail.matrix.deleteUnits': 'Delete Units',
    'projectDetail.matrix.deleteSelectedUnits': 'Delete selected units',
    'projectDetail.matrix.apply': 'Apply',
    'projectDetail.matrix.addDefect': 'Add Defect',
    'projectDetail.matrix.deleteDefect': 'Delete Defect',
    'projectDetail.report.unitWithoutUnitTypeWillNotShowinReport': 'Unit without unit type will not show in report',
    'projectDetail.gallery.tooltip': 'Use "banner" to set image as Project main image, Use "logo" to set image as Project logo',
    'projectFeature.propertyNearBy': 'Property Near By',
    'projectFeature.transportation': 'Transportation',
    'projectFacility.facility': 'Facilities',
    'sidebar.email': 'Email',
    'sidebar.account': 'Account',
    'sidebar.enquiry': 'Enquiry',
    'sidebar.enquiryDetail': 'Enquiry Detail',
    'sidebar.lead': 'Lead',
    'sidebar.ecommerce': 'Ecommerce',
    'sidebar.shop': 'Shop',
    'sidebar.cart': 'Cart',
    'sidebar.checkout': 'Checkout',
    'sidebar.cards': 'Cards',
    'sidebar.maps': 'Maps',
    'sidebar.googleMap': 'Google Map',
    'sidebar.leafletMap': 'Leaflet Map',
    'sidebar.calendar': 'Calendar',
    'sidebar.notes': 'Notes',
    'sidebar.todos': 'Todos',
    'sidebar.contacts': 'Contacts',
    'sidebar.shuffle': 'Shuffle',
    'sidebar.charts': 'Charts',
    'sidebar.googleCharts': 'Google Carts',
    'sidebar.recharts': 'Recharts',
    'sidebar.reactVis': 'React Vis',
    'sidebar.reactChart2': 'React-Chart-2',
    'sidebar.reactTrend': 'React-Trend',
    'sidebar.eChart': 'Echart',
    'sidebar.forms': 'Forms',
    'sidebar.input': 'Input',
    'sidebar.editor': 'Editor',
    'sidebar.formsWithValidation': 'Forms With Validation',
    'sidebar.progress': 'Progress',
    'sidebar.button': 'Button',
    'sidebar.tab': 'Tab',
    'sidebar.checkbox': 'Checkbox',
    'sidebar.radiobox': 'Radiobox',
    'sidebar.transfer': 'Transfer',
    'sidebar.autocomplete': 'AutoComplete',
    'sidebar.boxOptions': 'Box Options',
    'sidebar.uiElements': 'UI Elements',
    'sidebar.badge': 'Badge',
    'sidebar.card2': 'Card',
    'sidebar.corusel': 'Carousal',
    'sidebar.collapse': 'Collapse',
    'sidebar.popover': 'Pop Over',
    'sidebar.tooltip': 'Tooltip',
    'sidebar.tag': 'Tag',
    'sidebar.timeline': 'Timeline',
    'sidebar.dropdown': 'Dropdown',
    'sidebar.pagination': 'Pagination',
    'sidebar.rating': 'Rating',
    'sidebar.tree': 'Tree',
    'sidebar.advancedElements': 'Advanced Elements',
    'sidebar.reactDates': 'React Dates',
    'sidebar.codeMirror': 'Code Mirror',
    'sidebar.uppy': 'Uppy Uploader',
    'sidebar.dropzone': 'Drop Zone',
    'sidebar.feedback': 'Feedback',
    'sidebar.alert': 'Alert',
    'sidebar.modal': 'Modal',
    'sidebar.message': 'Message',
    'sidebar.notification': 'Notification',
    'sidebar.popConfirm': 'Pop Confirm',
    'sidebar.spin': 'Spin',
    'sidebar.tables': 'Tables',
    'sidebar.antTables': 'Ant Tables',
    'sidebar.pages': 'Pages',
    'sidebar.500': '500',
    'sidebar.404': '404',
    'sidebar.signIn': 'Sign In',
    'sidebar.signUp': 'Sign Up',
    'sidebar.forgotPw': 'Forgot Passwords',
    'sidebar.resetPw': 'Reset Passwords',
    'sidebar.invoice': 'Invoice',
    'sidebar.menuLevels': 'Menu Levels',
    'sidebar.item1': 'Item 1',
    'sidebar.item2': 'Item 2',
    'sidebar.option1': 'Option 1',
    'sidebar.option2': 'Option 2',
    'sidebar.option3': 'Option 3',
    'sidebar.option4': 'Option 4',
    'sidebar.blankPage': 'Blank Page',
    'sidebar.githubSearch': 'Github Search',
    'sidebar.youtubeSearch': 'Youtube Search',
    'sidebar.contactDetail': 'Contact Detail',
    'sidebar.enquiries': 'Enquiries',
    'sidebar.interests': 'Leads',
    'sidebar.properties': 'Properties',
    'sidebar.addProject': 'Add New Project',
    'sidebar.property': 'Property',
    'sidebar.residential': 'Residential',
    'sidebar.commercial': 'Commercial',
    'languageSwitcher.label': 'Language',
    'reports.label': 'Report',
    'themeSwitcher': 'Theme Switcher',
    'themeSwitcher.Sidebar': 'Sidebar',
    'themeSwitcher.Topbar': 'Topbar',
    'themeSwitcher.Background': 'Background',
    'feedback.alert.basicTitle': 'Basic Title',
    'feedback.alert.successText': 'Success text',
    'feedback.alert.infoText': 'Info Text',
    'feedback.alert.warningText': 'Warning Text',
    'feedback.alert.errorText': 'Error Text',
    'feedback.alert.closableAlertType': 'Closable Alert Type',
    'feedback.alert.iconAlertType': 'Icon Alert Type',
    'feedback.alert.iconInfoAlertType': 'Icon Info Alert Type',
    'feedback.alert.successTips': 'success tips',
    'feedback.alert.successTipsDescription': 'Detailed description and advices about successful copywriting.',
    'feedback.alert.informationTips': 'Informational Notes',
    'feedback.alert.informationDescription': 'Additional description and informations about copywriting.',
    'feedback.alert.warningTips': 'Warning',
    'feedback.alert.warningDescription': 'This is a warning notice about copywriting.',
    'feedback.alert.errorTips': 'Error',
    'feedback.alert.errorDescription': 'This is an error message about copywriting.',
    'feedback.alert.modalTitle': 'Modal one with customize Footer',
    'feedback.alert.modalSubTitle': 'Basic modal dialog.',
    'feedback.alert.successTitle': 'Success',
    'feedback.alert.infoTitle': 'Info',
    'feedback.alert.errorTitle': 'Error',
    'feedback.alert.warningTitle': 'Warning',
    'feedback.alert.modalBlockTitle': 'Modal',
    'feedback.alert.confirmationModalDialogue': 'Confirmation modal dialog',
    'feedback.alert.simpleModalDialogue': 'Simple modal dialog',
    'feedback.alert.message': 'Message',
    'feedback.alert.normalMessageTitle': 'Normal Message',
    'feedback.alert.normalMessageSubtitle': 'Normal messages as feedbacks.',
    'feedback.alert.displayMessage': 'Display normal message',
    'feedback.alert.displayOtherTypeMessageTitle': 'Other Types of Message',
    'feedback.alert.displayOtherTypeMessageSubTitle': 'Messages of success   error and warning types.',
    'feedback.alert.customizeDurationTitle': 'Customize duration',
    'feedback.alert.customizeDurationSubTitle': 'ustomize message display duration from default 1.5s to 10s.',
    'feedback.alert.customizeDurationButton': 'Customized display duration',
    'feedback.alert.messageLoadingTitle': 'Message of loading',
    'feedback.alert.messageLoadingSubTitle': 'Display a global loading indicator   which is dismissed by itself asynchronously' +
        '.',
    'feedback.alert.displayLoadIndicator': 'Display a loading indicator',
    'feedback.alert.notification': 'Notification',
    'feedback.alert.notificationBasicTitle': 'Basic',
    'feedback.alert.notificationBasicSubTitle': 'The simplest usage that close the notification box after 4.5s.',
    'feedback.alert.notificationBasicDescription': 'Open the notification box',
    'feedback.alert.notificationDurationTitle': 'Duration after which the notification box is closed',
    'feedback.alert.notificationDurationSubTitle': 'Duration can be used to specify how long the notification stays open. After the ' +
        'duration time elapses   the notification closes automatically. If not specified ' +
        '  default value is 4.5 seconds. If you set the value to 0   the notification box' +
        ' will never close automatically.',
    'feedback.alert.notificationwithIconTitle': 'Notification with icon',
    'feedback.alert.notificationwithIconSubTitle': 'A notification box with a icon at the left side.',
    'feedback.alert.notificationwithCustomIconTitle': 'Notification with custom icon',
    'feedback.alert.notificationwithCustomIconSubTitle': 'Normal messages as feedbacks.',
    'feedback.alert.notificationwithCustomButtonTitle': 'Notification with custom button',
    'feedback.alert.notificationwithCustomButtonSubTitle': 'Normal messages as feedbacks.',
    'feedback.alert.popConfirm': 'Pop Confirm',
    'feedback.alert.popConfirm.basicTitle': 'Basic Confirm',
    'feedback.alert.popConfirm.basicSubTitle': 'The basic example.',
    'feedback.alert.popConfirm.delete': 'Delete',
    'feedback.alert.popConfirm.notiWithIconTitle': 'Notification with custom icon',
    'feedback.alert.popConfirm.notiWithIconSubTitle': 'Normal messages as feedbacks.',
    'feedback.alert.popConfirm.TL': 'TL',
    'feedback.alert.popConfirm.top': 'Top',
    'feedback.alert.popConfirm.TR': 'TR',
    'feedback.alert.popConfirm.LT': 'LT',
    'feedback.alert.popConfirm.left': 'Left',
    'feedback.alert.popConfirm.LB': 'LB',
    'feedback.alert.popConfirm.RT': 'RT',
    'feedback.alert.popConfirm.right': 'Right',
    'feedback.alert.popConfirm.RB': 'RB',
    'feedback.alert.popConfirm.Bl': 'BL',
    'feedback.alert.popConfirm.bottom': 'Bottom',
    'feedback.alert.popConfirm.BR': 'BR',
    'feedback.alert.spin': 'Spin',
    'feedback.alert.spin.basicTitle': 'Size Spin',
    'feedback.alert.spin.background': 'Spin With Background',
    'feedback.alert.spin.backgroundDescription': 'Spin With Background description',
    'feedback.alert.spin.loadingState': 'Loading State',
    'feedback.alert.spin.alertTitle': 'Alert message title',
    'feedback.alert.spin.alertDescription': 'Further details about the context of this alert.',
    'feedback.alert.priceIsHigherThanPayment': 'Price is higher than payments.',
    'feedback.alert.paymentAreHigherThanPrice': 'Payments are higher than price.',
    'feedback.alert.warning.whenChangeTab': 'You haven\'t saved your data in this tab. Do you want to leave without saving?',
    'forms.input.header': 'Input',
    'forms.input.basicTitle': 'Basic usage',
    'forms.input.basicSubTitle': 'Basic usage example.',
    'forms.input.variationsTitle': 'Three sizes of Input',
    'forms.input.variationsSubtitle': 'There are three sizes of an Input box  large (42px  、default (35px   and small (' +
        '30px  . Note  Inside of forms   only the large size is used.',
    'forms.input.groupTitle': 'Input Group',
    'forms.input.groupSubTitle': 'Input.Group example Note  You dont need Col to control the width in the compact ' +
        'mode.',
    'forms.input.autoSizingTitle': 'Autosizing the height to fit the content',
    'forms.input.autoSizingSubTitle': 'autosize prop for a textarea type of Input makes the height to automatically adj' +
        'ust based on the content. An options object can be provided to autosize to speci' +
        'fy the minimum and maximum number of lines the textarea will automatically adjus' +
        't.',
    'forms.input.prePostTabTitle': 'Pre    Post tab',
    'forms.input.prePostTabSubTitle': 'Using pre &amp; post tabs example..',
    'forms.input.textAreaTitle': 'Textarea',
    'forms.input.textAreaSubTitle': 'For multi-line user input cases   an input whose type prop has the value of text' +
        'area can be used.',
    'forms.input.searchTitle': 'Search',
    'forms.input.searchSubTitle': 'Example of creating a search box by grouping a standard input with a search butt' +
        'on',
    'forms.editor.header': 'Editor',
    'forms.formsWithValidation.header': 'Customized Validation Form',
    'forms.formsWithValidation.failLabel': 'Fail',
    'forms.formsWithValidation.failHelp': 'Should be combination of numbers &amp; alphabets',
    'forms.formsWithValidation.warningLabel': 'Warning',
    'forms.formsWithValidation.ValidatingLabel': 'Validating',
    'forms.formsWithValidation.ValidatingHelp': 'The information is being validated...',
    'forms.formsWithValidation.SuccessLabel': 'Success',
    'forms.formsWithValidation.WarninghasFeedbackLabel': 'Warning',
    'forms.formsWithValidation.FailhasFeedbackLabel': 'Fail',
    'forms.formsWithValidation.FailhasFeedbackHelp': 'Should be combination of numbers &amp; alphabets',
    'forms.progressBar.header': 'Progress Bar',
    'forms.progressBar.standardTitle': 'Progress bar',
    'forms.progressBar.standardSubTitle': 'A standard progress bar.',
    'forms.progressBar.circularTitle': 'Circular Progress bar',
    'forms.progressBar.circularSubTitle': 'A circular progress bar.',
    'forms.progressBar.miniTitle': 'Mini size progress bar',
    'forms.progressBar.miniSubTitle': 'Appropriate for a narrow area.',
    'forms.progressBar.miniCircularTitle': 'A smaller circular progress bar.',
    'forms.progressBar.dynamicCircularTitle': 'Dynamic circular progress bar',
    'forms.progressBar.dynamicCircularSubTitle': 'A dynamic progress bar is better.',
    'forms.progressBar.customTextTitle': 'Custom text format',
    'forms.progressBar.customTextSubTitle': 'You can custom text format by setting format.',
    'forms.progressBar.dashboardTitle': 'Dashboard',
    'forms.progressBar.dashboardSubTitle': 'A dashboard style of progress.',
    'forms.button.header': 'Buttons',
    'forms.button.simpleButton': 'Button Type',
    'forms.button.iconButton': 'Button Icon',
    'forms.button.simpleButtonPrimaryText': 'Primary',
    'forms.button.simpleButtonDefaultText': 'Default',
    'forms.button.simpleButtonDashedText': 'Dashed',
    'forms.button.simpleButtonDangerText': 'Danger',
    'forms.button.iconPrimaryButton': 'search',
    'forms.button.iconSimpleButton': 'search',
    'forms.button.iconCirculerButton': 'search',
    'forms.button.iconDashedButton': 'search',
    'forms.button.SizedButton': 'Button Size',
    'forms.button.DisabledButton': 'Button Disabled',
    'forms.button.LoadingButton': 'Button Loading',
    'forms.button.MultipleButton': 'Multiple Button',
    'forms.button.groupButton': 'Button Group',
    'forms.Tabs.header': 'Tabs',
    'forms.Tabs.simpleTabTitle': 'search',
    'forms.Tabs.simpleTabSubTitle': 'Disabled Tabs',
    'forms.Tabs.iconTabTitle': 'Icon Tabs',
    'forms.Tabs.miniTabTitle': 'Mini Tabs',
    'forms.Tabs.extraTabTitle': 'Extra Action Tabs',
    'forms.Tabs.TabpositionTitle': 'Position',
    'forms.Tabs.TabpositionSubTitle': 'Tabss position  left   right   top or bottom',
    'forms.Tabs.cardTitle': 'Card Type Tabs',
    'forms.Tabs.editableTitle': 'Add and Close Tabs',
    'forms.Tabs.verticalTitle': 'Vertical Type Tabs',
    'forms.Tabs.basicTitle': 'Basic Tabs',
    'forms.checkbox.header': 'Checkbox',
    'forms.checkbox.basicTitle': 'Basic Checkbox',
    'forms.checkbox.basicSubTitle': 'Basic usage of checkbox.',
    'forms.checkbox.groupTitle': 'Checkbox Group',
    'forms.checkbox.groupSubTitle': 'Generate a group of checkboxes from an array. Use disabled to disable a checkbox' +
        '.',
    'forms.checkbox.groupCheckTitle': 'Checkbox Group',
    'forms.checkbox.groupCheckSubTitle': 'Generate a group of checkboxes from an array. Use disabled to disable a checkbox' +
        '.',
    'forms.radio.header': 'Radio',
    'forms.radio.simpleTitle': 'Basic Radio',
    'forms.radio.simpleSubTitle': 'The simplest use. Use disabled to disable a radio.',
    'forms.radio.groupTitle': 'Vertical RadioGroup',
    'forms.radio.groupSubTitle': 'Vertical RadioGroup   with more radios.',
    'forms.radio.groupSecondTitle': 'RadioGroup',
    'forms.radio.groupSecondSubTitle': 'A group of radio components.',
    'forms.radio.groupThirdTitle': 'RadioGroup',
    'forms.radio.groupThirdSubTitle': 'A group of radio components.',
    'forms.transfer.header': 'Transfer',
    'forms.transfer.SubTitle': 'Transfer with a search box.',
    'forms.transfer.Title': 'Search',
    'forms.autocomplete.header': 'Autocomplete',
    'forms.autocomplete.simpleTitle': 'Customized',
    'forms.autocomplete.simpleSubTitle': 'You could pass AutoComplete.Option as children of AutoComplete   instead of usin' +
        'g dataSource',
    'forms.autocomplete.customizeTitle': 'Customize Input Component',
    'forms.autocomplete.customizeSubTitle': 'Customize Input Component',
    'uiElements.badge.badge': 'Badge',
    'uiElements.badge.basicExample': 'Basic Example',
    'uiElements.badge.basicExampleSubTitle': 'Simplest Usage. Badge will be hidden when count is 0   but we can use showZero t' +
        'o show it.',
    'uiElements.badge.overflowCount': 'Overflow Count',
    'uiElements.badge.overflowCountSubTitle': 'OverflowCount is displayed when count is larger than overflowCount. The default ' +
        'value of overflowCount is 99.',
    'uiElements.badge.status': 'Status',
    'uiElements.badge.statusSubTitle': 'Standalone badge with status.',
    'uiElements.badge.success': 'Success',
    'uiElements.badge.error': 'Error',
    'uiElements.badge.default': 'Default',
    'uiElements.badge.processing': 'Processing',
    'uiElements.badge.warning': 'Warning',
    'uiElements.badge.redBadge': 'Red badge',
    'uiElements.badge.redBadgeSubTitle': 'This will simply display a red badge   without a specific count.',
    'uiElements.badge.linkSomething': 'Link something',
    'uiElements.cards.cards': 'Cards',
    'uiElements.cards.basicCard': 'Basic card',
    'uiElements.cards.basicCardSubTitle': 'A basic card containing a title   content and an extra corner content.',
    'uiElements.cards.more': 'More',
    'uiElements.cards.cardTitle': 'Card Title',
    'uiElements.cards.cardContent': 'Card content',
    'uiElements.cards.lorem': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam   quis no' +
        'strud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    'uiElements.cards.noBorder': 'No Border',
    'uiElements.cards.noBorderSubTitle': 'A borderless card on a gray background.',
    'uiElements.cards.gridCard': 'Grid card',
    'uiElements.cards.gridCardSubTitle': 'Cards usually cooperate with grid layout in overview page.',
    'uiElements.cards.loadingCard': 'Loading card',
    'uiElements.cards.loadingCardSubTitle': 'Shows a loading indicator while the contents of the card is being fetched.',
    'uiElements.cards.whateverContent': 'Whatever content',
    'uiElements.cards.customizedContentTitle': 'Customized Content',
    'uiElements.cards.customizedContent': 'Shows a loading indicator while the contents of the card is being fetched.',
    'uiElements.cards.europeStreetBeat': 'Europe Street beat',
    'uiElements.cards.instagram': 'www.instagram.com',
    'uiElements.carousel.carousel': 'Carousal',
    'uiElements.carousel.verticalCarousel': 'Vertical Carousel',
    'uiElements.carousel.verticalCarouselSubTitle': 'Vertical pagination. use   vertical=true',
    'uiElements.carousel.basicCarousel': 'Basic Carousel',
    'uiElements.carousel.basicCarouselSubTitle': 'Basic usage',
    'uiElements.carousel.fadeInTransition': 'Fade In Transition',
    'uiElements.carousel.fadeInTransitionSubTitle': 'Slides use fade for transition.   effect=fade',
    'uiElements.carousel.scrollAutomatically': 'Scroll Automatically',
    'uiElements.carousel.scrollAutomaticallySubTitle': 'Timing of scrolling to the next card  picture. autoplay',
    'uiElements.collapse.collapse': 'Collapse',
    'uiElements.collapse.collapseSubTitle': 'More than one panel can be expanded at a time   the first panel is initialized t' +
        'o be active in this case. use   defaultActiveKey=  [keyNum]',
    'uiElements.collapse.text': 'A dog is a type of domesticated animal. Known for its loyalty and faithfulness  ' +
        ' it can be found as a welcome guest in many households across the world.',
    'uiElements.collapse.headerOne': 'This is panel header 1',
    'uiElements.collapse.headerTwo': 'This is panel header 2',
    'uiElements.collapse.headerThree': 'This is panel header 3',
    'uiElements.collapse.headerNested': 'This is panel nest panel',
    'uiElements.collapse.nestedExample': 'Nested Example',
    'uiElements.collapse.nestedExampleSubTitle': 'Collapse is nested inside the Collapse.',
    'uiElements.collapse.borderlessExample': 'Borderless Example',
    'uiElements.collapse.borderlessExampleSubTitle': 'A borderless style of Collapse. use   bordered=  false',
    'uiElements.collapse.accordion': 'Accordion',
    'uiElements.collapse.accordionSubTitle': 'Accordion mode   only one panel can be expanded at a time. The first panel will ' +
        'be expanded by default. use accordion',
    'uiElements.popover.popover': 'Popover',
    'uiElements.popover.basicExample': 'Basic Example',
    'uiElements.popover.basicExampleSubTitle': 'The most basic example. The size of the floating layer depends on the contents r' +
        'egion.',
    'uiElements.popover.hoverMe': 'Hover me',
    'uiElements.popover.title': 'Title',
    'uiElements.popover.titleTrigger': 'Three ways to trigger',
    'uiElements.popover.titleTriggerSubTitle': 'Mouse to click   focus and move in.',
    'uiElements.popover.focusMe': 'Focus me',
    'uiElements.popover.clickMe': 'Click me',
    'uiElements.popover.placement': 'Placement',
    'uiElements.popover.placementSubTitle': 'There are 12 placement options available.',
    'uiElements.popover.top': 'Top',
    'uiElements.popover.topLeft': 'Top Left',
    'uiElements.popover.topRight': 'Top Right',
    'uiElements.popover.leftTop': 'Left Top',
    'uiElements.popover.left': 'Left',
    'uiElements.popover.leftBottom': 'Left Bottom',
    'uiElements.popover.rightTop': 'Right Top',
    'uiElements.popover.right': 'Right',
    'uiElements.popover.bottom': 'Bottom',
    'uiElements.popover.bottomLeft': 'Bottom Left',
    'uiElements.popover.bottomRight': 'Bottom Right',
    'uiElements.popover.boxTitle': 'Controlling the close of the dialog',
    'uiElements.popover.boxSubTitle': 'Use visible prop to control the display of the card.',
    'uiElements.popover.TR': 'TR',
    'uiElements.popover.TL': 'TL',
    'uiElements.popover.LT': 'LT',
    'uiElements.popover.LB': 'LB',
    'uiElements.popover.RT': 'RT',
    'uiElements.popover.RB': 'RB',
    'uiElements.popover.BL': 'BL',
    'uiElements.popover.BR': 'BR',
    'uiElements.popover.close': 'Close',
    'uiElements.tooltip.tooltip': 'Tooltip',
    'uiElements.tooltip.tooltipContent': 'Tooltip Content',
    'uiElements.tooltip.basicExample': 'Basic Example',
    'uiElements.tooltip.basicExampleSubTitle': 'The simplest usage.',
    'uiElements.tooltip.placementTitle': 'Placement',
    'uiElements.tooltip.placementSubTitle': 'The ToolTip has 12 placements choice.',
    'uiElements.tooltip.TL': 'TL',
    'uiElements.tooltip.TR': 'TR',
    'uiElements.tooltip.LT': 'LT',
    'uiElements.tooltip.LB': 'LB',
    'uiElements.tooltip.RT': 'RT',
    'uiElements.tooltip.RB': 'RB',
    'uiElements.tooltip.BL': 'BL',
    'uiElements.tooltip.BR': 'BR',
    'uiElements.tooltip.bottom': 'Bottom',
    'uiElements.tooltip.right': 'Right',
    'uiElements.tooltip.left': 'Left',
    'uiElements.tooltip.top': 'Top',
    'uiElements.tooltip.tooltipContentSpan': 'Tooltip will show when mouse enter.',
    'uiElements.tooltip.contentSpan': 'Tooltip Content',
    'uiElements.tags.tags': 'Tags',
    'uiElements.tags.basicExample': 'Basic Example',
    'uiElements.tags.basicExampleSubTitle': 'Usage of basic Tag   and it could be closable by set closable property. Closable' +
        ' Tag supports onClose afterClose events.',
    'uiElements.tags.tagOne': 'Tag 1',
    'uiElements.tags.tagTwo': 'Tag 2',
    'uiElements.tags.link': 'Link',
    'uiElements.tags.preventDefault': 'Prevent Default',
    'uiElements.tags.colorfulTag': 'Colorful Tag',
    'uiElements.tags.hotTags': 'Hot Tags',
    'uiElements.tags.hotTagsSubTitle': 'Select your favourite topics.',
    'uiElements.tags.hots': 'Hots',
    'uiElements.tags.addRemoveDynamically': 'Add & Remove Dynamically',
    'uiElements.tags.addRemoveDynamicallySubTitle': 'Generating a set of Tags by array   you can add and remove dynamically. Its base' +
        'd on afterClose event   which will be triggered while the close animation end.',
    'uiElements.tags.newTag': '+ New Tag',
    'uiElements.timeline.timeline': 'Timeline',
    'uiElements.timeline.basicExample': 'Basic Example',
    'uiElements.timeline.basicTimeline': 'Basic timeline',
    'uiElements.timeline.lastNode': 'Last Node',
    'uiElements.timeline.lastNodeContent': 'When the timeline is incomplete and ongoing   put a ghost node at last. set   pe' +
        'nding=  true     or   pending=  a React Element',
    'uiElements.timeline.seeMore': 'See more',
    'uiElements.timeline.custom': 'Custom',
    'uiElements.timeline.customContent': 'Set a node as an icon or other custom element.',
    'uiElements.timeline.colorExample': 'Color Example',
    'uiElements.timeline.colorExampleContent': 'Set the color of circles. green means completed or success status   red means wa' +
        'rning or error   and blue means ongoing or other default status.',
    'uiElements.timeline.createServiceSite': 'Create a services site 2015-09-01',
    'uiElements.timeline.solveInitialNetwork': 'Solve initial network problems 2015-09-01',
    'uiElements.timeline.networkProblemSolved': 'Network problems being solved 2015-09-01',
    'uiElements.timeline.technicalTesting': 'Technical testing 2015-09-01',
    'uiElements.dropdown.dropdown': 'Dropdown',
    'uiElements.dropdown.hoverDropdown': 'Hover Drop Down',
    'uiElements.dropdown.hoverMe': 'Hover me',
    'uiElements.dropdown.hoverPlacement': 'Hover Placement Drop Down',
    'uiElements.dropdown.hoverDisableLink': 'Hover Drop Down with Disable link',
    'uiElements.dropdown.clickedDropdown': 'Clicked Drop Down',
    'uiElements.dropdown.buttonDropdown': 'Button with dropdown menu',
    'uiElements.pagination.pagination': 'Pagination',
    'uiElements.pagination.basic': 'Basic',
    'uiElements.pagination.more': 'More',
    'uiElements.pagination.changer': 'Changer',
    'uiElements.pagination.jumper': 'Jumper',
    'uiElements.pagination.miniSize': 'Mini Size',
    'uiElements.pagination.simpleMode': 'Simple Mode',
    'uiElements.pagination.controlled': 'Controlled',
    'uiElements.pagination.totalNumber': 'Total Number',
    'uiElements.rating.rating': 'Rating',
    'uiElements.rating.basicExample': 'Basic Example',
    'uiElements.rating.basicExampleSubTitle': 'The simplest usage.',
    'uiElements.rating.halfStar': 'Half star',
    'uiElements.rating.halfStarSubTitle': 'Support select half star.',
    'uiElements.rating.showCopywriting': 'Show copywriting',
    'uiElements.rating.showCopywritingSubTitle': 'Add copywriting in rate components.',
    'uiElements.rating.readOnly': 'Read only',
    'uiElements.rating.readOnlySubTitle': 'Read only   cant use mouse to interact.',
    'uiElements.rating.otherCharacter': 'Other Character',
    'uiElements.rating.otherCharacterSubTitle': 'Replace the default star to other character like alphabet   digit   iconfont or ' +
        'even Chinese word.',
    'uiElements.tree.tree': 'Tree',
    'uiElements.tree.basicExample': 'Basic example',
    'uiElements.tree.basicExampleSubTitle': 'The most basic usage   tell you how to use checkable   selectable   disabled   d' +
        'efaultExpandKeys   and etc.',
    'uiElements.tree.basicControlledExample': 'Basic controlled example',
    'uiElements.tree.basicControlledExampleSubTitle': 'basic controlled example',
    'uiElements.tree.draggableExample': 'Draggable example',
    'uiElements.tree.draggableExampleSubTitle': 'Drag treeNode to insert after the other treeNode or insert into the other parent' +
        ' TreeNode.',
    'uiElements.tree.loadAsync': 'Load data asynchronously',
    'uiElements.tree.loadAsyncSubTitle': 'To load data asynchronously when click to expand a treeNode.',
    'uiElements.tree.searchableExample': 'Searchable example',
    'uiElements.tree.searchableExampleSubTitle': 'Searchable Tree',
    'uiElements.tree.treeWithLine': 'Tree With Line',
    'shuffle.descriptionOne': 'Netscape 2.0 ships   introducing Javascript',
    'shuffle.descriptionTwo': 'Jesse James Garrett releases AJAX spec',
    'shuffle.descriptionThree': 'jQuery 1.0 released',
    'shuffle.descriptionFour': 'First underscore.js commit',
    'shuffle.descriptionFive': 'Backbone.js becomes a thing',
    'shuffle.descriptionSix': 'Angular 1.0 released',
    'shuffle.descriptionSeven': 'React is open-sourced; developers rejoice',
    'toggle.list': 'List',
    'toggle.grid': 'Grid',
    'toggle.ascending': 'Ascending',
    'toggle.descending': 'Descending',
    'toggle.shuffle': 'Shuffle',
    'toggle.rotate': 'Rotate',
    'toggle.addItem': 'Add Item',
    'toggle.removeItem': 'Remove Item',
    'contactlist.searchContacts': 'Search Contacts',
    'contactlist.addNewContact': 'Add New Contact',
    'notes.ChoseColor': 'Choose a color for your note',
    'notes.addNote': 'Add New Note',
    'page404.title': '404',
    'page404.subTitle': 'Looks like you got lost',
    'page404.description': 'The page youre looking for doesnt exist or has been moved.',
    'page404.backButton': 'BACK HOME',
    'page500.title': '500',
    'page500.subTitle': 'Internal Server Error',
    'page500.description': 'Something went wrong. Please try again later.',
    'page500.backButton': 'BACK HOME',
    'page.forgetPassTitle': 'Isomorphic',
    'page.forgetPassSubTitle': 'Forgot Password?',
    'page.forgetPassDescription': 'Enter your email and we send you a reset link.',
    'page.sendRequest': 'Send request',
    'page.resetPassTitle': 'Isomorphic',
    'page.resetPassSubTitle': 'Reset Password',
    'page.resetPassDescription': 'Enter new password and confirm it.',
    'page.resetPassSave': 'Save',
    'page.signInTitle': 'Saga Property',
    'page.signInRememberMe': 'Remember me',
    'page.signInButton': 'Sign in',
    'page.signInPreview': 'username: demo   password: demodemo   or just click on any button.',
    'page.signInFacebook': 'Sign in with Facebook',
    'page.signInGooglePlus': 'Sign in with Google Plus',
    'page.signInAuth0': 'Sign in with Auth0',
    'page.signInForgotPass': 'Forgot password',
    'page.signInCreateAccount': 'Create an Isomorphoic account',
    'page.signUpTitle': 'Isomorphic',
    'page.signUpTermsConditions': 'I agree with terms and condtions',
    'page.signUpButton': 'Sign Up',
    'page.signUpFacebook': 'Sign up with Facebook',
    'page.signUpGooglePlus': 'Sign up with Google Plus',
    'page.signUpAuth0': 'Sign Up with Auth0',
    'page.signUpAlreadyAccount': 'Already have an account? Sign in.',
    'page.signingIn': 'Logging in..',
    'page.signInInvalidInput': 'Invalid login or password',
    'login.invalidToken': 'Invalid login token',
    'page.selectOffice': 'Select Office',
    'widget.reportswidget.label': 'Income',
    'widget.reportswidget.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.singleprogresswidget1.label': 'Marketing',
    'widget.singleprogresswidget2.label': 'Addvertisement',
    'widget.singleprogresswidget3.label': 'Consulting',
    'widget.singleprogresswidget4.label': 'Development',
    'widget.stickerwidget1.number': '210',
    'widget.stickerwidget1.text': 'Unread Email',
    'widget.stickerwidget2.number': '1749',
    'widget.stickerwidget2.text': 'Image Upload',
    'widget.stickerwidget3.number': '3024',
    'widget.stickerwidget3.text': 'Total Message',
    'widget.stickerwidget4.number': '54',
    'widget.stickerwidget4.text': 'Orders Post',
    'widget.salewidget1.label': 'Income',
    'widget.salewidget1.price': '$15000',
    'widget.salewidget1.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.salewidget2.label': 'Income',
    'widget.salewidget2.price': '$15000',
    'widget.salewidget2.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.salewidget3.label': 'Income',
    'widget.salewidget3.price': '$15000',
    'widget.salewidget3.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.salewidget4.label': 'Income',
    'widget.salewidget4.price': '$15000',
    'widget.salewidget4.details': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r',
    'widget.cardwidget1.number': '110',
    'widget.cardwidget1.text': 'New Messages',
    'widget.cardwidget2.number': '100%',
    'widget.cardwidget2.text': 'Volume',
    'widget.cardwidget3.number': '137',
    'widget.cardwidget3.text': 'Achievement',
    'widget.progresswidget1.label': 'Download',
    'widget.progresswidget1.details': '50% Complete',
    'widget.progresswidget2.label': 'Support',
    'widget.progresswidget2.details': '80% Satisfied Customer',
    'widget.progresswidget3.label': 'Upload',
    'widget.progresswidget3.details': '65% Complete',
    'widget.vcardwidget.name': 'Jhon Doe',
    'widget.vcardwidget.title': 'Sr. iOS Developer',
    'widget.vcardwidget.description': 'Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempo' +
        'r ammet dolar consectetur adipisicing elit',
    'checkout.billingform.firstname': 'First Name',
    'checkout.billingform.lastname': 'Last Name',
    'checkout.billingform.company': 'Company Name',
    'checkout.billingform.email': 'Email Address',
    'checkout.billingform.mobile': 'Mobile No',
    'checkout.billingform.country': 'Country',
    'checkout.billingform.city': 'City',
    'checkout.billingform.address': 'Address',
    'checkout.billingform.addressoptional': 'Apartment   suite   unit etc. (optional',
    'checkout.billingform.checkbox': 'Create an account?',
    'antTable.title.image': 'Image',
    'antTable.title.firstName': 'First Name',
    'antTable.title.lastName': 'Last Name',
    'antTable.title.city': 'City',
    'antTable.title.street': 'Street',
    'antTable.title.email': 'Email',
    'antTable.title.dob': 'DOB',
    'Map.leaflet.basicTitle': 'Basic Map',
    'Map.leaflet.basicMarkerTitle': 'Basic Map(With Default Marker',
    'Map.leaflet.leafletCustomMarkerTitle': 'Basic Map(With Custom Icon Marker)',
    'Map.leaflet.leafletCustomHtmlMarkerTitle': 'Basic Map(With Custom Html Marker',
    'Map.leaflet.leafletMarkerClusterTitle': 'Basic Map(With Marker Cluster',
    'Map.leaflet.leafletRoutingTitle': 'Basic Map Routing',
    'Component.contacts.noOption': 'No contact found',
    'email.send': 'SEND',
    'email.cancel': 'CANCEL',
    'email.compose': 'COMPOSE',
    'email.noMessage': 'Please select a mail to read',
    'themeSwitcher.purchase': 'PURCHAGE NOW',
    'themeSwitcher.settings': 'Settings',
    'sidebar.selectbox': 'Select',
    'sidebar.frappeChart': 'Frappe Charts',
    'topbar.help': 'Help',
    'topbar.logout': 'Logout',
    'topbar.viewAll': 'View All',
    'topbar.viewCart': 'View Cart',
    'topbar.totalPrice': 'Total Price',
    'sidebar.projectDetail': 'Project Detail',
    'sidebar.projectList': 'Project List',
    'sidebar.propertyList': 'Property List',
    'dashboard': 'Dashboard',
    'sidebar.settings': 'Settings',
    'sidebar.settings.employeelist': 'Employee List',
    'sidebar.settings.officelist': 'Office Information',
    'sidebar.salesReport': 'Sales Report',
    'sidebar.ExcelList': 'Excel List',
    'sidebar.PropertyReport': 'Property Report',
    'sidebar.PropertyStatusReport': 'Property Status Report',
    'modalConfirm.button.confirm': 'Confirm',
    'modalConfirm.button.ContinueAnyWay': 'Continue anyway',
    'modalConfirm.button.cancel': 'Cancel',
    'commission.title.agentName': 'Agent Name',
    'commission.title.commission': 'Commission',
    'offer.date': 'Date',
    'offer.documentName': 'Document Name',
    'offer.offerName': 'Offer',
    'offer.agentName': 'Sales Representative',
    'offer.createOffer': 'Make an Offer',
    'offer.createContract': 'Create Contract',
    'offer.detail.header.detail': 'Detail',
    'offer.detail.header.amount': 'Amount',
    'offer.detail.header.validityPeriod': 'Validity Period',
    'offer.detail.header.buyerInformation': 'Buyer Information',
    'offer.detail.header.sellerInformation': 'Seller Information',
    'offer.detail.header.sellerAndBuyerInformation': 'Seller/Buyer Information',
    'offer.detail.header.sellingInformationWillPullFromPropertyOwner': 'Selling information will pull from property owner information',
    'offer.detail.name': 'Offer Name',
    'offer.detail.insuranceCompany': 'Insurance Company',
    'offer.detail.pleaseSelectInsuranceCompany': 'Select insurace company',
    'offer.detail.offerStatus': 'Offer Status',
    'offer.detail.contract': 'Contract',
    'offer.detail.contract.createFromThisOffer': 'Create new contract from this offer',
    'offer.detail.contract.cannotCreateContractFromthisOffer': 'Contract cannot be created by declined offer',
    'offer.detail.offeredPrice': 'Offered Price',
    'offer.detail.deposit': 'Deposit',
    'offer.detail.validFrom': 'Valid From',
    'offer.detail.validUntil': 'Valid Until',
    'offer.status.firstOffer': 'First Offer',
    'offer.status.counterOffer': 'Counter Offer',
    'offer.status.acceptedOffer': 'Accepted Offer',
    'offer.status.declinedOffer': 'Declined Offer',
    'offer.button.update': 'Update',
    'offer.button.create': 'Create Offer',
    'offer.description.buyerProvision': 'Buyer Provision',
    'offer.description.ownerProvision': 'Owner Provision',
    'offer.description.backside':'Backside',
    'offer.description.documentTemplate':'Document Template',
    'offer.payment':'Payment',
    'offer.payment.appraisal': 'Appraisal',
    'offer.payment.propertyAppraisal':'Property Appraisal',
    'offer.payment.loanDisclaimer':'Loan Disclaimer',
    'buyerInformation.name': 'Name',
    'buyerInformation.homePhone': 'Home Phone',
    'buyerInformation.nationalId': 'National ID',
    'buyerInformation.workPhone': 'Work Phone',
    'buyerInformation.address': 'Address',
    'buyerInformation.mobilePhone': 'Mobile Phone',
    'buyerInformation.ownerPercent': '% Owner',
    'buyerInformation.lineId': 'Line ID',
    'buyerInformation.email': 'Email',
    'buyerInformation.addOneMoreBuyer': 'Add one more buyer',
    'buyerInformation.addOneMoreRenter': 'Add one more renter',
    'buyerInformation.notFoundContact': 'Not Found (Please add in contact first)',
    'buyerInformation.signature': 'Signature',
    'buyerInformation.hideBuyerName': 'Hide buyer name',
    'buyerInformation.displayInBuyerList': 'Display in buyer list',
    'buyerInformation.displayInSellerList': 'Display in seller list',
    'buyerInformation.displaySignature': 'Display signature',

    // OWNER MODULE
    'OwnerInformation.addOneMoreOwner': 'Add one more owner',

    // CONTRACT MODULE
    'contract.contractPrice': 'Contract Price',
    'contract.menu.contractDetail': 'Contract Detail',
    'contract.menu.paymentBreakdown': 'Payment BreakDown',
    'contract.menu.text': 'Text',
    'contract.menu.commission': 'Commission',
    'contract.menu.history': 'History',
    'contract.menu.deedDetail': 'Deed Detail',
    'contract.menu.deedDescription': 'Description',
    'contract.detail.title.contractDetail': 'Contract Detail',
    'contract.detail.contractName': 'Contract Name',
    'contract.detail.insuranceCompany': 'Insurance Company',
    'contract.detail.associatedOffer': 'Associated Offer',
    'contract.detail.contractDate': 'Contract Date',
    'contract.detail.transferDate': 'Handover date.',
    'contract.detail.deedDate': 'Deed Date',
    'contract.detail.transferDateText': 'Handover date. (Text)',
    'contract.detail.previousDeedDue': 'Previous Deed Due',
    'contract.detail.title.buyerInfomation': 'Buyer Infomation',
    'contract.detail.enterContractName': 'Enter contract name',
    'contract.paymentBreakdown.title.paymentBreakdown': 'Payment Breakdown',
    'contract.paymentBreakdown.propertyAppraisal': 'Property Appraisal',
    'contract.paymentBreakdown.fireAppraisal': 'Fire Appraisal',
    'contract.paymentBreakdown.landAppraisal': 'Land Appraisal',
    'contract.text.title.frontSideText': 'Front Side Text',
    'contract.text.title.buyerConditions': 'Buyer Conditions',
    'contract.text.title.sellerConditions': 'Seller Conditions',
    'contract.text.title.backSideText': 'Back Side Text',
    'contract.text.templates': 'templates',
    'contract.text.signningLcation': 'signning location',
    'contract.commission.title.commissionDistribution': 'Commission Distribution',
    'contract.commission.title.PaymentReceived': 'Payment Received',
    'contract.commission.commissionPercent': 'Commission Percent',
    'contract.commission.commissionFixed': 'Commission Fixed Amount',
    'contract.commission.commissionTotal': 'Commission Total',
    'contract.commission.receiver': 'Receiver',
    'contract.commission.fixed': 'Fixed',
    'contract.commission.total': 'Total',
    'contract.commission.grandTotal': 'Grand Total',
    'contract.commission.receivedOn': 'Receiverd On',
    'contract.history.title.history': 'History',
    'contract.history.createOn': 'Date',
    'contract.history.agentName': 'Agent Name',
    'contract.history.action': 'History',
    'excelList.header.allEmployeeCommission': 'All employee commission',
    'excelList.button.exportExcel': 'Export Excel',
    'contract.createDeed': 'Create Deed',
    'contract.deed.deedPrice': 'Deed Price',
    'contract.deed': 'Deed',
    'contract.deed.deedDetail': 'Deed Detail',
    'contract.deed.deedName': 'Deed Name',
    'contract.deed.enterDeedName': 'Enter Deed Name',
    'contract.deed.deedDescription': 'Deed Description',
    'contract.deed.insurance': 'Insurance',
    'contract.deed.buyerProvision': 'Buyer Provision',
    'contract.deed.ownerProvision': 'Owner Provision',
    'contract.deed.salesRepresentative': 'Sales Representative',
    'contract.deed.enterBuyerProvision': 'Enter Buyer Provision',
    'contract.deed.enterOwnerProvision': 'Enter Owner Provision',
    'contract.deed.paymentBreakdown.title.paymentBreakdown': 'Payment Breakdown',
    'contract.deed.paymentBreakdown.propertyAppraisal': 'Property Appraisal',
    'contract.deed.paymentBreakdown.fireAppraisal': 'Fire Appraisal',
    'contract.deed.paymentBreakdown.landAppraisal': 'Land Appraisal',
    'contract.deed.paymentBreakdown.DeliveryDateText': 'Handover Date - Text',
    'contract.deed.paymentBreakdown.DeliveryDate': 'Handover Date',
    'contract.deed.paymentBreakdown.OfferPrice': 'Offer Price',
    'contract.deed.paymentBreakdown.Town': 'Sign Place',
    'contract.deed.paymentBreakdown.SignDate': 'Sign Date',
    'contract.deed.paymentBreakdown.ContractDate': 'Contract Date',
    'contract.deed.paymentBreakdown.DeedDate': 'Deed Date',
    'contract.deed.paymentBreakdown.TransferDate': 'Cancellation Date',
    'contract.deed.paymentBreakdown.PreviousDeedDate': 'Previous Deed Due',
    'contract.deed.associatedContract': 'Associated Contract',
    'contract.deed.paymentBreakdown.rentPeriod': 'Rent Period',
    'contract.deed.paymentBreakdown.advancePayment': 'Advance Payment',
    'contract.deed.paymentBreakdown.paymentFrequency': 'Payment Frequency',
    'contract.deed.paymentBreakdown.moveInDate': 'Move In Date',
    'contract.deed.paymentBreakdown.moveInDateText': 'Move In Date - Text',
    'property.description': 'Description',
    'property.description.full': 'Description',
    'property.description.forReport': 'Description (for report)',
    'property.description.renovetions': 'Renovations',
    'property.description.knownDefects': 'Known defects',
    'property.description.openHouse': 'Open House',
    'property.description.from': 'From',
    'property.description.to': 'To',
    'property.description.advertisement': 'Advertisement',
    'property.description.button.getStandardText': 'Get Standard Text',
    'property.description.button.saveStandardText': 'Save Standard',
    'property.description.button.save': 'Save',

    // SETTING MODULE
    'setting.menu.enquiry.status': 'Contact/Enquiry',
    'setting.menu.project.status': 'Project',
    'setting.menu.employee.status': 'Employee',
    'setting.menu.office.status': 'Office',
    'setting.menu.propertyAndProject.status': 'Property/Project',
    'setting.menu.sale.status': 'Sales',
    'setting.menu.employee.detail': 'Employee Detail',
    'setting.menu.employee.passwordAndAuthentication': 'Authentication/Publishing',
    'setting.menu.employee.salesHistory': 'Sales History',
    'setting.text.title.statusName': 'Status Name',
    'setting.text.title.statusDetail': 'Detail',
    'setting.text.title.sourceName': 'Source Name',
    'setting.propertyAndProject.header.defect': 'Defect',
    'setting.propertyAndProject.header.delivery': 'Delivery',
    'setting.propertyAndProject.header.documentTemplate': 'Document Template',
    'setting.propertyAndProject.header.entrance': 'Entrance',
    'setting.propertyAndProject.header.heating': 'Heating',
    'setting.propertyAndProject.header.index': 'Index',
    'setting.propertyAndProject.header.commercialIndex': 'Commercial Index',
    'setting.propertyAndProject.header.insurance': 'Insurance',
    'setting.propertyAndProject.header.language': 'Language',
    'setting.propertyAndProject.header.material': 'Material',
    'setting.propertyAndProject.header.mortgagee': 'Mortgagee',
    'setting.propertyAndProject.header.propertyType': 'Property Type',
    'setting.propertyAndProject.header.livingPropertyType': 'Living Property Type',
    'setting.propertyAndProject.header.commercialPropertyType': 'Commercial Property Type',
    'setting.propertyAndProject.header.status': 'Status',
    'setting.propertyAndProject.header.projectStatus': 'Project Status',
    'setting.propertyAndProject.header.propertyStatus': 'Property Status',
    'setting.propertyAndProject.header.source': 'Source',
    'setting.propertyAndProject.header.projectSource': 'Project Source',
    'setting.propertyAndProject.header.propertySource': 'Property Source',
    'setting.propertyAndProject.header.usage': 'Usage',
    'setting.propertyAndProject.header.window': 'Window',
    'setting.propertyAndProject.table.item': 'Item',
    'setting.propertyAndProject.table.desc': 'Description',    
    'setting.enquiry.header.source': 'Enquiry Source',
    'setting.enquiry.header.source.contact': 'Contact source',
    'setting.enquiry.header.source.enquiry': 'Enquiry source',
    'setting.salesCommission.header.Commission': 'Commission',
    'setting.salesCommission.header.title': 'Commission Table',
    'setting.salesCommission.table.accumulateSalesFrom': 'Accumulate Commission From',
    'setting.salesCommission.table.accumulateSalesTo': 'Accumulate Commission To',
    'setting.salesCommission.table.commissionRate': 'Commission Rate',
    'setting.salesCommission.button.edit': 'Edit',
    'setting.salesCommission.button.delete': 'Delete',
    'setting.salesCommission.button.add': 'Add',
    'setting.salesCommission.button.updateCommission': 'Update Commission',

    'setting.documentTemplate.text': 'Document Template',
    'setting.documentTemplate.name': 'Document Name',
    'setting.documentTemplate.type': 'Type',
    'setting.documentTemplate.docType': 'Document Type',
    'setting.documentTemplate.docType.offer': 'Offer',
    'setting.documentTemplate.docType.contract': 'Contract',
    'setting.documentTemplate.newDoc': 'New Document Template',

    'setting.documentTemplate.dynamicTag': 'Dynamic Tag',
    'setting.documentTemplate.propertyname': 'Property Name',
    'setting.documentTemplate.propertyprice': 'Property Price',
    'setting.documentTemplate.propertypricetext': 'Property Price Text',
    'setting.documentTemplate.propertyaddress': 'Address 1',
    'setting.documentTemplate.propertyaddress2': 'Address 2',
    'setting.documentTemplate.propertyhousenumber': 'House Number',
    'setting.documentTemplate.propertysize': 'Property space',
    'setting.documentTemplate.propertyfloor': 'Property no of floor',
    'setting.documentTemplate.propertydeedno': 'Property deed no.',
    'setting.documentTemplate.propertyowner': 'Property owner',
    'setting.documentTemplate.propertyownerall': 'Property owner (All)',
    'setting.documentTemplate.documentname': 'Offer, Contract, Deed Name',
    'setting.documentTemplate.sellprice': 'Offer, Contract, Deed price',
    'setting.documentTemplate.buyername': 'Buyer Name',
    'setting.documentTemplate.buyernameall': 'Buyer Name (All)',
    'setting.documentTemplate.buyerid': 'Buyer ID number',
    'setting.documentTemplate.buyeridall': 'Buyer ID number (All)',
    'setting.documentTemplate.transferdate': 'Transfer Date',
    'setting.documentTemplate.contractdate': 'Contract Date',
    'setting.documentTemplate.deeddate': 'Deed Date',
    'setting.documentTemplate.previousdeeddue': 'Previous Deed Due',
    'setting.documentTemplate.paymentrec1': 'Payment Breakdown #1',
    'setting.documentTemplate.paymentrec2': 'Payment Breakdown #2',
    'setting.documentTemplate.paymentsummary': 'Payment Breakdown Summary',
    'setting.documentTemplate.mortgagesummary': 'Mortgage summary',
    'setting.documentTemplate.ilssummary': 'ILS Loan summary',
    'setting.documentTemplate.ilsextrasummary': 'ILS Loan Extra summary',
    'setting.documentTemplate.newloansummary': 'New Loan summary',
    'setting.documentTemplate.bondsummary': 'Bond summary',
    'setting.documentTemplate.allpaymentsummary': 'All Payment Summary',
    'setting.documentTemplate.ownerid': 'Owner ID',
    'setting.documentTemplate.owneridall': 'Owner ID (All)',

    'setting.documentTemplate.propertyownerphone': 'Property owner phone',
    'setting.documentTemplate.buyerphone': 'Buyer phone',
    'setting.documentTemplate.propertyowneremail': 'Property owner email',
    'setting.documentTemplate.buyeremail': 'Buyer email',
    'setting.documentTemplate.propertyowneraddress': 'Property owner address',
    'setting.documentTemplate.buyeraddress': 'Buyer address',
    'setting.documentTemplate.propertyownerage': 'Property owner age',
    'setting.documentTemplate.buyerage': 'Buyer age',
    'setting.documentTemplate.offerstartdate': 'Offer start date',
    'setting.documentTemplate.offerenddate': 'Offer end date',
    'setting.documentTemplate.offerstartdatebe': 'Offer start date B.E.',
    'setting.documentTemplate.offerenddatebe': 'Offer end date B.E.',
    'setting.documentTemplate.contractdatebe': 'Contract date B.E.',
    'setting.documentTemplate.transferdatebe': 'Transfer date B.E.',
    'setting.documentTemplate.deeddatebe': 'Deed date B.E.',
    'setting.documentTemplate.propertylandsize': 'Property land size',
    'setting.documentTemplate.propertylandsizeth': 'Property land size, Thai unit',
    'setting.documentTemplate.landnumber': 'Land number',
    'setting.documentTemplate.salename': 'Sale name',
    'setting.documentTemplate.salephone': 'Sale phone',
    'setting.documentTemplate.propertycommission': 'Property commission',
    'setting.documentTemplate.propertycommissionfixed': 'Property fixed commission',
    'setting.documentTemplate.propertyexpiredate': 'Property listing expire date',
    'setting.documentTemplate.currentdate': 'Current date',
    'setting.documentTemplate.currentdatebe': 'Current date B.E.',
    'setting.documentTemplate.signplace': 'Sign place',
    'setting.documentTemplate.saleaddress': 'Sale address',
    'setting.documentTemplate.saleage': 'Sale age',
    'setting.documentTemplate.propertyexpiredatebe': 'Property listing expire date B.E.',

    'setting.office.officeName': 'Office Name',
    'setting.office.companyId': 'Company ID',
    'setting.office.postalAddress': 'Postal Address',
    'setting.office.general': 'General',
    'setting.office.phoneNumber': 'Phone number',
    'setting.office.altAddress': 'Address2',
    'setting.office.faxNumber': 'Fax number',
    'setting.office.sagaOfficeId': 'Saga office ID',
    'setting.office.website': 'Website',
    'setting.office.showOnWeb': 'Show company detail on web',
    'setting.office.agentIsolation': 'Agent isolation',
    'setting.office.allowTextSelection': 'Enable text highlight',
    'setting.office.allowProjectList': 'Allow project list',
    'setting.office.showQuickView': 'Enable quick view',
    'setting.office.showAgentDirectCall': 'Show agent direct call',
    'setting.office.agentMapUrl': 'Agent Map Url',
    'setting.office.slogan': 'Slogan',
    'setting.office.closer': 'Closer',
    'setting.office.marketingBullet1': 'Marketing Bullet 1',
    'setting.office.marketingBullet2': 'Marketing Bullet 2',
    'setting.office.marketingBullet3': 'Marketing Bullet 3',
    'setting.office.reportLogo': 'Report Logo',
    'setting.office.webLogo': 'Web Logo',
    'setting.office.waterMark': 'Watermark',
    'setting.office.defaultProperty': 'Default property',
    'setting.office.officeDetail': 'Office Detail',
    'setting.office.buyerCosts': 'Buyer Costs',
    'setting.office.loanCost': 'Loan Cost',
    'setting.office.stampDutyContract': 'Stamp duty for contract',
    'setting.office.notarizingContract': 'Notarizing of contract',
    'setting.office.loanCostOfExtraLoan': 'Loan cost of extra loan',
    'setting.office.stampDutyForLoan': 'Stamp duty for loan',
    'setting.office.notarizingOfLoan': 'Notarizing of loan',
    'setting.office.officeCost': 'Office cost',
    'setting.office.fmrEnabled': 'FMR Enabled',
    'setting.office.fmrAddress': 'FMR Address',
    'setting.office.cityID': 'City ID',
    'setting.office.admakerAddress': 'Admaker Address',
    'setting.office.integratorId': 'Integrator ID',
    'setting.office.regionId': 'Region ID',
    'setting.office.trixboxAddress': 'Trixbox Address',
    'setting.office.integratorOfficeId': 'Integrator Office ID',
    'setting.office.intlOfficeId': 'Intl Office ID',
    'setting.office.externalPortal': 'External/Portal',
    'setting.office.portal': 'Portal',
    'setting.office.portalName': 'Name',
    'setting.office.email': 'Email',
    'setting.office.public': 'Public',
    'setting.office.enable': 'Enabled',
    'setting.office.csEnable': 'CS Enabled',
    'setting.office.default': 'Default',
    'setting.office.userName': 'Username',
    'setting.office.password': 'Password',
    'setting.office.url': 'URL',
    'setting.office.darkpoolID': 'Darkpool ID',
    'setting.office.darkpoolKey': 'Darkpool Key',
    'setting.office.sendUsers': 'Send Users',
    'setting.office.sendProperty': 'Send Properties',
    'setting.office.darkpoolAddress': 'Darkpool Address',
    'setting.office.darkpoolAddressNote': 'Please note that putting colon (:) symbol at any place in address will cut the address at that position when sending to web.',
    'setting.office.darkpoolAddressFormat': 'Address Format',
    'setting.office.sendAsInSagaEign': 'Send as it is in SagaEign',
    'setting.office.sendOnlyStreetName': 'Send only street name',
    'setting.employee.header.id': 'ID',
    'setting.employee.header.userName': 'User Name',
    'setting.employee.header.name': 'Name',
    'setting.employee.header.role': 'Role',
    'setting.employee.header.email': 'Email',
    'setting.employee.header.mobilePhone': 'Mobile Phone',
    'setting.employee.header.status': 'Status',
    'setting.employee.showInactiveUser': 'Show inactive users',
    'setting.employee.addNewEmployee': 'Add New User',
    'setting.employee.detail.general': 'General',
    'setting.employee.detail.firstName': 'First Name',
    'setting.employee.detail.middleName': 'Middle Name',
    'setting.employee.detail.lastName': 'Last Name',
    'setting.employee.detail.ssn': 'SSN',
    'setting.employee.detail.dateOfBirth': 'Date of birth',
    'setting.employee.detail.gender': 'Gender',
    'setting.employee.detail.lineId': 'Line ID',
    'setting.employee.detail.lineQR': 'Line QR',
    'setting.employee.detail.workNumber': 'Work number',
    'setting.employee.detail.mobileNumber': 'Mobile number',
    'setting.employee.detail.mobileNumber2': 'Mobile Number 2',
    'setting.employee.detail.otherNumber': 'Other Number',
    'setting.employee.detail.website': 'Website',
    'setting.employee.detail.publishing': 'Publishing',
    'setting.employee.detail.showEmployeeDetailOnWeb': 'Show employee detail on web',
    'setting.employee.detail.showPictureInSalesReport': 'Show picture in sales report',
    'setting.employee.detail.showPictureInPropertyList': 'Show picture in property list',
    'setting.employee.detail.job': 'Job',
    'setting.employee.detail.titile': 'Title',
    'setting.employee.detail.teamStatus': 'Team Status',
    'setting.employee.detail.slogan': 'Slogan',
    'setting.employee.detail.closer': 'Closer',
    'setting.employee.detail.languages': 'Languages',
    'setting.employee.detail.specialities': 'Specialities',
    'setting.employee.detail.educations': 'Educations',
    'setting.employee.detail.description': 'Description',
    'setting.employee.detail.marketingBullet1': 'Marketing Bullet 1',
    'setting.employee.detail.agentId': 'Agent ID',
    'setting.employee.detail.sagaUserId': 'SAGA user ID',
    'setting.employee.detail.ddPropertyAgentId': 'DDProperty agent ID',
    'setting.employee.detail.dateRegistered': 'Date registerd',
    'setting.employee.detail.watermark': 'Watermark',
    'setting.employee.detail.applyWatermarkWhenSendingToWeb': 'Apply watermark when sending to web',
    'setting.employee.detail.applyWatermarkWhenSendinOnEmain': 'Apply watermark when sending on email',
    'setting.employee.detail.applyWatermarkWhenDownloadingPhotos': 'Apply watermark when downloading photos',
    'setting.employee.detail.watermarkPosition': 'Watermark position',
    'setting.employee.detail.massPropertyUpdateFunctions': 'Mass property update functions',
    'setting.employee.detail.updatePropertiesFromFMR': 'Update properties from FMR',
    'setting.employee.detail.updatePropertiesOnWeb': 'Update properties on web',
    'setting.employee.detail.updatePropertiesFromFMRRemark': 'Clicking on this button will update all your properties with information from FMR. Properties, which are parts of large complexes and share property ID with other parts, will not be updated, but shown to you, so that you can manually choose which parts are they. Updating property with FMR information will update properties on the web',
    'setting.employee.detail.updatePropertiesOnWebRemark': 'If you feel that some of properties are not up to date on the web, you can update all of them by clicking on this button',
    'setting.employee.detail.paymentSetting': 'Payment setting',
    'setting.employee.detail.percentCutOfSalesFee': '% cut of sales fee',
    'setting.employee.detail.Salary': 'Salary',
    'setting.employee.detail.Bonus': 'Bonus',
    'setting.employee.detail.yearPaymentsToTheOffice': 'Yearly payments to the office',
    'setting.employee.detail.MonthlyInconeForTheOfficeFrom': 'Monthly income for the office from',
    'setting.employee.detail.perYear': 'Per year',
    'setting.employee.detail.perMonth': 'Per month',
    'setting.employee.detail.otherPaymentsToOffice1': 'Other payments to office 1',
    'setting.employee.detail.otherPaymentsToOffice2': 'Other payments to office 2',
    'setting.employee.detail.contractPayment': 'Contract payment',
    'setting.employee.detail.authentication': 'Authentication',
    'setting.employee.detail.username': 'Username',
    'setting.employee.detail.oldPassword': 'Old password',
    'setting.employee.detail.newPassword': 'New Password',
    'setting.employee.detail.confirmNewPassword': 'Confirm new password',
    'setting.employee.detail.password': 'Password',
    'setting.employee.detail.confirmPassword': 'Confirm password',
    'setting.employee.detail.admakerUsername': 'Admarker Username',
    'setting.employee.detail.admakerPassword': 'Admarker Password',
    'setting.employee.detail.rights': 'Rights',
    'setting.employee.detail.expireDate': 'Expire Date',
    'setting.employee.detail.inactiveThisUser': 'Inactive this user',
    'setting.employee.detail.inactiveThisUserRemark': "This user will can't access this system, but all property still assigned to the user",
    'setting.employee.detail.activeThisUser': 'Active this user',
    'setting.employee.detail.autogenerateUsename': 'Auto generate username',
    'setting.employee.detail.inactiveModal.header': 'Properties of a user who is being de-activated',
    'setting.employee.detail.inactiveModal.title1': 'User who is being de-activated has ',
    'setting.employee.detail.inactiveModal.title2': ' active properties ( ',
    'setting.employee.detail.inactiveModal.title3': ' of them are on the web) and ',
    'setting.employee.detail.inactiveModal.title4': ' properties in storage. What would you like to do?',
    'setting.employee.detail.inactiveModal.movetoUser': 'Move all properties to another user',
    'setting.employee.detail.inactiveModal.keepPropertiesOnWeb': 'Keep properties on the web as they are now',
    'setting.employee.detail.inactiveModal.pullPropertiesInStorage': 'Put all properties in storage (properties which are on the web will be removed from the web and all properties can be found in Storage tab in property list under de-activated user)',
    'setting.employee.detail.inactiveModal.doNothing': 'Do nothing',
    'setting.employee.detail.inactiveModal.warning': 'Warning: action selected above and confirmed by clicking OK can not be rolled back later.',
    'setting.employee.detail.isAuthorized': 'Is authorized',
    'setting.employee.detail.allowCreateUsers': 'Allow create users',
    'setting.employee.detail.restrictExport': 'Restrict export',
    'setting.employee.detail.isAllowViewContact': 'Is allow view contact',
    'setting.employee.detail.ssl': 'SSL',
    'setting.employee.detail.sentToMeAsBcc': 'Send to me as Bcc',
    'setting.employee.detail.smtpServerName': 'SMTP Server name',
    'setting.employee.detail.smtpUsername': 'SMTP Username',
    'setting.employee.detail.smtpPassword': 'SMTP Password',
    'setting.employee.detail.smtpPort': 'SMTP Port',
    'setting.employee.detail.pop3ServerName': 'POP3 Server name',
    'setting.employee.detail.pop3Username': 'POP3 Username',
    'setting.employee.detail.pop3Password': 'POP3 Password',
    'setting.employee.detail.pop3Port': 'POP3 Port',
    'setting.employee.detail.signature': 'Signature',

    'setting.propertylist.availableList': 'Available list',
    'setting.propertylist.selectedList': 'Selected list',
    'setting.propertylist.moveUp': 'Move up',
    'setting.propertylist.moveDown': 'Move down',
    'setting.propertylist.update': 'Update',

    'alert.notfoundData': 'Not found data',
    'type': 'Type',
    'customer': 'Customer',
    'description': 'Description',
    'enquiry': 'Enquiry',
    'enquiry.source': 'Source',
    'enquiry.memo': 'Memo',
    'enquiry.addnote': 'Add-Note',
    'enquiry.name': 'Name',
    'enquiry.status': 'Status',
    'enquiry.dateAdded': 'Date added',
    'enquiry.saleRepresentative': 'Sale representative',
    'enquiry.findMatchTooltip': 'Find the properties that meet the criteria',
    'save': 'Save',
    'dashboard.addmore': 'Add More',
    'note': 'Note',
    'amount': 'Amount',
    'editor.writeSomething': 'Write Something',
    'restore': 'Restore',
    'addmore': 'Add More',
    'delete': 'Delete',
    'edit': 'Edit',
    'cancel': 'Cancel',
    'ok': 'OK',
    'update': 'Update',
    'sureDelete': 'Sure to Delete?',
    'sureCancel': 'Sure to Cancel?',
    'sureDone': 'Sure to Done?',
    'done': 'Done',
    'search': 'Search',
    'default': 'Default',
    'setDefault': 'Set Default',
    'clear': 'Clear',
    'firstProject' : 'First property',
    'view': 'View',
    'upload': 'Upload',
    'deleteSelectedRecord': 'Delete selected records',

    // ERRORS FROM UI-VALIDATION
    'error.offerDetail.name': 'Please input offer name',
    'error.offerDetail.name.exceedLength': `Offer name can't exceed 255 characters`,
    'error.offerDetail.price': 'Offer price value must be greater than 0',
    'error.offerDetail.offerStart': 'Please select offer start date',
    'error.offerDetail.offerEnd': 'Please select offer end date',
    'error.contractDetail.name': 'Please input contract name.',
    'error.projectDetail.projectName': 'Please input project name',
    'error.projectDetail.projectRegId': 'Please input project id',
    'error.projectDetail.projectTypes': 'Please select project types',
    'error.projectDetail.developer': 'Please input developer',
    'error.projectDetail.totalUnits': 'Please input total units',
    'error.projectDetail.province': 'Please select province',
    'error.projectDetail.district': 'Please select district',
    'error.projectDetail.area': 'Please select area',
    'error.projectDetail.address': 'Please input address',
    'error.projectDetail.yearBuilt': 'Please input year built',
    'error.projectDetail.yearComplete': 'Year complete must be greater than year built',
    'error.projectDetail.status': 'Please select status',
    'error.projectDetail.landSize': 'Please input land size',
    'error.projectDetail.landSize2': 'Please enter land size value greater than 0',
    'error.projectDetail.rai': 'Please input rai',
    'error.projectDetail.ngan': 'Please input ngan',
    'error.projectDetail.wa': 'Please input wa',
    'error.projectDetail.projectIsDelete': 'This project is deleted.',
    'error.projectDetail.permissionDenied': 'Permission Denied.',
    'error.projectDetail.videoLink': 'Please enter YouTube URL',
    'error.projectUnit.unitName': 'Please input unit name',
    'error.projectUnit.unitType': 'Please select unit types',
    'error.projectUnit.size': 'Please input size/size value must more than 0',
    'error.projectEnquiry.contact': 'Please select contact',
    'error.projectEnquiry.propertyType': 'Please select property type',
    'error.projectEnquiry.size': 'Size To must be greater than size',
    'error.projectEnquiry.landSize':  'Land Size To must be greater than land size',
    'error.projectEnquiry.price': 'Price To must be greater than price',
    'error.projectEnquiry.priceStart': 'Please input price start',
    'error.projectEnquiry.priceTo': 'Please input price to',
    'error.addNewUnit.unitNumber': 'Please input unit number',
    'error.addNewUnit.invalidUnitNumber': 'Invalid format unit number',
    'error.addNewUnit.price': 'Please input price',
    'error.addNewUnit.price2': 'Price must be greater than minimum price',
    'error.addNewUnit.minimumPrice': 'Please input minimum price',
    'error.salesCommissionSetting.data.atleastone': 'Please input commision data at least 1 record',
    'error.salesCommissionSetting.data.moreThanZero': 'Please enter accumulate commission from or accumulate commission to more than zero',
    'error.salesCommissionSetting.data.fromMoreThanTo': 'Please enter accumulate commission from more than accumulate commission to',
    'error.salesCommissionSetting.data.nonOverLap': 'Please enter non overlap accumulate commission value',
    'error.salesCommissionSetting.data.continuous': 'Please enter continuous accumulate commission value',
    'error.salesCommissionSetting.data.cannotBeEmpty': 'Please enter accumulate commission from, accumulate commission to or commission rate',
    'error.deedDetail.name': 'Please input deed name.',
    'error.deedDetail.id': 'Please input deed detail.',
    'error.priceToMustGreaterThanPriceFrom': 'Price to must be greater than price from',
    'error.minPriceToMustGreaterThanPriceFrom': 'Minimum price to must be greater than minimum price from',
    'error.pleaseInputPriceFrom': 'Please input price from',
    'error.pleaseInputPriceTo': 'Please input price to',
    'error.pleaseInputMinPriceFrom': 'Please input minimum price from',
    'error.pleaseInputMinPriceTo': 'Please input minimum price to',
    'error.pleaseInputName': 'Please input name',
    'error.pleaseInputEmail': 'Please input email',
    'error.pleaseInputUsername': 'Please input username',
    'error.pleaseInputPassword': 'Please input password',
    'error.pleaseInputOldPassword': 'Please input old password',
    'error.pleaseInputConfirmPassword': 'Please input confirm password',
    'error.pleaseInputValidEmail': 'The input is not valid E-mail!',
    'error.uploadLimitExceed': 'Images upload exceed limit',

    // NOTIFICATIONS
    'notification.savecomplete': 'Save complete',

    // Languages
    'language.th.sidebar': 'ภาษาไทย',
    'language.en.sidebar': 'English',
    'language.is.sidebar': 'íslenska',

    /* ERRORS from saga */
    'INVALID_LOGIN': 'Invalid Login',
    
    /*projectDetailNewUnitModal*/
    'projectDetailNewUnit.input.unitNumer': 'Unit Number',
    'projectDetailNewUnit.input.unitNumer.tooltip': 'Type unit number and/or unit ranges separated by commas, e.g. 1, 3, 5-12',
    'projectDetailNewUnit.input.rentOrSale': 'Rent/Sale',
    'projectDetailNewUnit.input.sale': 'Sale',
    'projectDetailNewUnit.input.rent': 'Rent',
    'projectDetailNewUnit.input.unitType': 'Unit Type',
    'projectDetailNewUnit.input.price': 'Price',
    'projectDetailNewUnit.input.minimumPrice': 'Lowest Price',
    'projectDetailNewUnit.input.selectUnitType': 'Select Unit Type',
    'projectDetailNewUnit.header.newUnit': 'New Units',
    'projectDetailNewUnit.button.generate': 'Generate',
    
    /*projectDetailNewEnquiryModal*/
    'projectDetailNewEnquiry.select.pleaseSelect': 'Please Select',
    'projectDetailNewEnquiry.select.contact': 'Contact Name',
    'projectDetailNewEnquiry.select.rentOrSale': 'Rent/Sale',
    'projectDetailNewEnquiry.select.rent': 'Rent',
    'projectDetailNewEnquiry.select.sale': 'Sale',
    'projectDetailNewEnquiry.input.type': 'Type',
    'projectDetailNewEnquiry.select.propertyType': 'Property Type',
    'projectDetailNewEnquiry.input.sizeStart': 'Size (sqm)',
    'projectDetailNewEnquiry.input.sizeEnd': 'To',
    'projectDetailNewEnquiry.input.landStart': 'Land Size (sqm)',
    'projectDetailNewEnquiry.input.landEnd': 'To',
    'projectDetailNewEnquiry.input.priceStart': 'Price',
    'projectDetailNewEnquiry.input.priceEnd': 'To',
    'projectDetailNewEnquiry.input.noOfBedrooms': 'No of Bedrooms',
    'projectDetailNewEnquiry.select.province': 'Province',
    'projectDetailNewEnquiry.select.city': 'City',
    'projectDetailNewEnquiry.select.zone': 'Zone',
    'projectDetailNewEnquiry.input.description': 'Description',
    'projectDetailNewEnquiry.select.source': 'Source',
    'projectDetailNewEnquiry.select.status': 'Status',
    'projectDetailNewEnquiry.header.newEnquiry': 'New Enquiry',
    'projectDetailNewEnquiry.button.save': 'Save',
    'projectDetailNewEnquiry.button.cancel': 'Cancel',

    'report.propertyReport.propertyReport': 'Property Report',
    'report.propertyReport.isExclusive': 'Is Exclusive',
    'report.propertyReport.dateFrom': 'Date From',
    'report.propertyReport.dateTo': 'Date To',
    'report.propertyReport.advanceFilter': 'Advance Filter',
    'report.propertyReport.propertyId': 'Property ID',
    'report.propertyReport.address2': 'Address2',
    'report.propertyReport.priceFrom': 'Price From',
    'report.propertyReport.priceTo': 'Price To',
    'report.propertyReport.exclusive': 'Exclusive',
    'report.propertyReport.nonExclusive': 'Non Exclusive',

    'description.forReport': 'Description (for report)',
    'description.standardText': 'Get Standard Text',
    'description.saveStandardText': 'Save Standard Text',
    'description.renovation': 'Renovation',
    'description.knownDefects': 'Known Defects',
    'description.openHouse': 'Description (Open House)',
    'description.advertisement': 'Advertisement',
    'description.portal': 'Portal Description',

    'alertModal.duplicateBuyer': "Buyer duplicated, Can't added",
    'alertModal.duplicateOwner': "Owner duplicated, Can't added",


    'oldLoan':'Old Loan',
    'ilsloan': 'ILS Loan',
    'newLoan': 'New Loan',
    'bond': 'Bonds',
    'loan.propertyLoan': 'Property Loan',
    'loan.takenLoan': 'Taken Loan',
    'loan.mortgageRight': 'Mortgage Right',
    'loan.takeOver': 'Take Over',
    'loan.mortgagee': 'Mortgagee',
    'loan.interest': 'Interests',
    'loan.originalAmount': 'Original Amount',
    'loan.loanRemainder': 'Loan Remainder',
    'loan.payment':'Payment',
    'loan.remainingPayment':'Remaining Payment',
    'loan.nextPaymentDue':'Next Payment Due',
    'loan.takenOverSum': 'Taken over loan summary',
    'loan.canceledSum': 'Cancel summary',
    'loan.agreedSum': 'Agreed summary',
    'loan.paymentPerPeriodSum': 'Payment per period summary',
    'loan.loanAmountSum': 'Loan amount summary',
    'loan.loanTakenOn':'Loan Taken on',
    'loan.costToPay':'Cost to Pay',
    'loan.baseIndex':'Base Index',
    'loan.firstPayment':'First Payment',
    'loan.lockedRemainder':'Locked Remainder',
    'loan.AdditionalAmount': 'Additional Amount',
    'loan.InterestedCalculatedFrom': 'Interests Calculated from',
    'loan.InterestedCalculatedFromText': 'Interests Calc. from - Text',
    'loan.paymentPerYear': 'Payment per year',
    'loan.numberOfYear': 'Number of year',
    'loan.numberOfPayment': 'Number of payments',
    'loan.standardText': 'Standard Text',
    'loan.title': 'Loan Title',
    'loan.payOutDate': 'Loan pay out date',
    'bond.title': 'Bond Title',
    'loan.contractDate': 'Contract Date',
    'loan.deedDate': 'Deed Date',
    'loan.transferDate': 'Transfer Date',
    'loan.previousDeedDue': 'Previous Deed Due',

    'contact.allContacts': 'All Contacts',
    'contact.myContacts': 'My Contacts',
    'contact.allEnquiries': 'All Enquiries',
    'contact.myEnquiries': 'My Enquiries',
    'contact.allLeads': 'All Leads',
    'contact.myLeads': 'My Leads',
    'contact.dateAdded': 'Date Added',
    'contact.exportSelected': 'Export Selected',
    'contact.exportAll': 'Export All',
    'contact.contactDetail.ssn': 'SSN',
    'contact.contactDetail.homeAddress': 'Home Address',
    'contact.contactDetail.homePhone': 'Home Phone',
    'contact.contactDetail.workPhone': 'Work Phone',
    'contact.contactDetail.mobilePhone': 'Mobile Phone',
    'contact.contactDetail.email': 'Email',
    'contact.contactDetail.lineId': 'Line ID',
    'contact.contactDetail.company': 'Company',
    'contact.contactDetail.position': 'Position',
    'contact.contactDetail.website': 'Website',
    'contact.contactDetail.spouse': 'Spouse',
    'contact.contactDetail.birthDate': 'Birth Date',
    'contact.contactDetail.assignToSale': 'Assign to Sale',
    'contact.contactDetail.source': 'Source',
    'contact.contactDetail.status': 'Status',
    'contact.contactDetail.remind': 'Remind',
    'contact.contactDetail.memo': 'Memo',
    'contact.contactDetail.signature': 'Signature',
    'contact.contactDetail.button.email': 'Email',
    'contact.contactDetail.button.nameCard': 'Name Card',
    'contact.contactDetail.button.calendar': 'Calendar',
    'contact.contactDetail.button.relatedProperty': 'Rel Properties',
    'contact.contactDetail.button.relatedDocument': 'Related Document',
    'contact.contactDetail.button.leads': 'Leads',
    'contact.contactDetail.button.enquiries': 'Enquiries',
    'contact.contactDetail.propertyStatus': 'Property Status',
    'contact.contactDetail.relatedStatus': 'Related Status',
    'contact.contactDetail.relatedProperty': 'Related Properties',

    'enquiry.enquiryDetail.create': 'Add New Enquiry',
    'enquiry.enquiryDetail.update': 'Enquiry Detail',
    'enquiry.enquiryDetail.mustSelectlease1Field':'Must have value lease 1 field.',
    'enquiry.matchProperty.utilizeSpace':'Utilize space',
    'enquiry.matchProperty.action':'Action',
    'enquiry.matchProperty.created':'Created',
    'enquiry.matchProperty.createLead':'Create Lead',
    'enquiry.matchProperty.findMatched':'Find Matched',
    'enquiry.matchProperty.matchedProperties':'Matched Properties',

    'lead.table.header.propertyname': 'Property Name',
    'lead.leadDetail.header': 'Lead Detail',
    'lead.leadDetail.customerName': 'Customer Name',
    'lead.leadDetail.interestedProperty': 'Interested Property',
    'lead.leadDetail.callDate': 'Call Date',
    'lead.leadDetail.openHouse': 'Open House',
    'lead.leadDetail.source': 'Source',
    'lead.leadDetail.status': 'Status',
    'lead.leadDetail.noPropertyName': 'No property name',

    'batch.source' : 'Source',
    'batch.status' : 'Status',
    'batch.selectStatus': 'Select Status',
    'batch.selectSource': 'Select Source',
    'batch.selectOnWeb': 'Select On web',

    'email.to': 'To',
    'email.cc': 'Cc',
    'email.subject': 'Subject',
    'email.sendEmail': 'Send Email',
    'email.attachmentPolicy': 'Image file must smaller than 1 MB/Other file must smaller than 10 MB',
    'email.sendComplete': 'Email has been sent',

    'contact.sendDetail': 'Send Detail',


    'offerEvent': `Offer's event`,
    'contractEvent': `Contract's event`,
    'deedEvent': `Deed's event`,
    'leadEvent': `Lead's event`,
    'propertyactivityEvent': `Property Activity`,
    'birthdayEvent': 'Birthday',
    'propertyopenhouseEvent': 'Property OpenHouse Date',
    'propertyexpireEvent': 'Listing expired date',
    'calendar.myCalendar': 'My Calendar',
    'calendar.allCalendar': 'All Calendar',

    'loan.newLoan.NumberOfPaymentsHelp':'This amount will calculate from Payment per year multipiled by Number of year',
    
    'financialStatement.portalAddress': 'Portal Address',
    'financialStatement.paymentSummary': 'Payment summary',
    'financialStatement.offerPrice': 'Offer price',
    'financialStatement.mortgage': 'Mortgage',
    'financialStatement.ilsLoan': 'ILS Loan',
    'financialStatement.ilsLoanExtra': 'ILS Loan Extra',
    'financialStatement.newLoan': 'New Loan',
    'financialStatement.bonds': 'Bonds',
    'financialStatement.paymentSum': 'Payment sum',
    'financialStatement.diff': 'Different',

    'propertyList.myProperty':'My Properties',
    'propertyList.allProperty':'All Properties',
    'propertyList.owner':'Owner',
    'propertyList.modifiedOn': 'Modified on',
    'propertyList.propertyAddress':'Property address',
    'propertyList.addProperty':'Add Property',
    'propertyList.newForSale':'New for Sale',
    'propertyList.newForRent':'New for Rent',
    'propertyList.recentActivity':'Recent Activity',

    'propertyDetail': 'Property Detail',
    'propertyDetail.description': 'Description',
    'propertyDetail.findLocationFromAddress': 'Find location from address',
    'propertyDetail.updateFromFMR': 'Update from FMR',
    'propertyDetail.viewOnFMR': 'View on FMR',
    'propertyDetail.landNumber': 'Land Number',
    'propertyDetail.landSize': 'Land Size',
    'propertyDetail.landSizeSqm': 'Land Size (Sq.m)',
    'propertyDetail.propertyPart': 'Property Part',
    'propertyDetail.houseAppraisal': 'House Appraisal',
    'propertyDetail.buildingFloor': 'Building floors',
    'propertyDetail.unitFloor': `Unit's floors`,
    'propertyDetail.bedroom': 'Bedroom(s)',
    'propertyDetail.bathroom': 'Bathroom(s)',
    'propertyDetail.livingroom': 'Living room(s)',
    'propertyDetail.totalroom': 'Total room(s)',
    'propertyDetail.aircondition': 'Air condition(s)',
    'propertyDetail.parkingLot': 'Parking lot(s)',
    'propertyDetail.storage': 'Storage(s)',
    'propertyDetail.balcony': 'Balcony(s)',
    'propertyDetail.laundry': 'Laundry(s)',
    'propertyDetail.garden': 'Garden(s)',
    'propertyDetail.otherroom': 'Other room(s)',
    'propertyDetail.buildingStage': 'Building Stage',
    'propertyDetail.delivery': 'Delivery',
    'propertyDetail.entrance': 'Entrance',
    'propertyDetail.heating': 'Heating',
    'propertyDetail.windows': 'Windows',
    'propertyDetail.groundFloorMaterial': 'Ground floor material',
    'propertyDetail.upperFloorMaterial': 'Upper floor material',
    'propertyDetail.elevator': 'Elevator',
    'propertyDetail.preemption': 'Preemption',
    'propertyDetail.exchangeAgreementNo': 'Exchange agreement no.',
    'propertyDetail.mapSheetNo': 'Mapsheet no.',
    'propertyDetail.parcelNo': 'Parcel no.',
    'propertyDetail.dealingFileNo': 'Dealing file no.',
    'propertyDetail.groundLeaseAgreementNo': 'Ground lease agreement no.',
    'propertyDetail.encumbranceFileNo': 'Encumbrance file no.',
    'propertyDetail.encumbranceStatement': 'Encumbrance Statement',
    'propertyDetail.encumbranceNote': 'Encumbrance note',
    'propertyDetail.taxAndCost': 'Taxes and Costs',
    'propertyDetail.orderTax': 'Order tax',
    'propertyDetail.waterTax': 'Water tax',
    'propertyDetail.fireInsurance': 'Fire insurance',
    'propertyDetail.orderInsurance': 'Order insurance',
    'propertyDetail.monthlyCost': 'Monthly cost',
    'propertyDetail.rentalDetail': 'Rental detail',
    'propertyDetail.rentPeriod': 'Rent period',
    'propertyDetail.paymentFrequency': 'Payment frequency',
    'propertyDetail.rentInsurance1': 'Rent insurance 1',
    'propertyDetail.rentInsurance2': 'Rent insurance 2',
    'propertyDetail.deliveryFrom': 'Delivery from',
    'propertyDetail.deliveryTo': 'Delivery to',
    'propertyDetail.electricity': 'Electricity',
    'propertyDetail.water': 'Water',
    'propertyDetail.other': 'Other(s)',
    'propertyDetail.index': 'Index',
    'propertyDetail.propertyManagement': 'Property management',
    'propertyDetail.management': 'Management',
    'propertyDetail.janitorSalary': `Janitor's salary`,
    'propertyDetail.cleaningOfJointArea': 'Cleaning of joint area',
    'propertyDetail.electricityInJointArea': 'Electricity in joint area',
    'propertyDetail.cleaningOfWasteDisposalArea': 'Cleaning of waste disposal area',
    'propertyDetail.homeOwnerInsurance': 'Home owner insurance',
    'propertyDetail.paymentDueDate': 'Payment due date',
    'propertyDetail.commercialBuildingSpecification': 'Commercial building specification',
    'propertyDetail.premisesSize': `Premises's size (Length x Width) (m)`,
    'propertyDetail.buildingSize': `Building's size (Length x Width) (m)`,
    'propertyDetail.floorArea': 'Floor area (Sq.m)',
    'propertyDetail.loftArea': 'Loft area (Sq.m)',
    'propertyDetail.bearingCapacity': 'Bearing capacity (Ton/Sq.m)',
    'propertyDetail.ridgeHeight': 'Ridge height (m)',
    'propertyDetail.highestWall': 'Highest wall (m)',
    'propertyDetail.lowestWall': 'Lowest wall (m)',
    'propertyDetail.sizeInCubicMeter': 'Size in cubic meters (Cu.m)',
    'propertyDetail.noOfDirveThroughDoor': 'No. of drive-through doors',
    'propertyDetail.heightOfDriveThroughDoor': 'Height of drive-through doors (m)',
    'propertyDetail.roof': 'Roof',
    'propertyDetail.noOfGroundParkingSpace': 'No. of ground parking spaces',
    'propertyDetail.buildingRight': 'Building right (Sq.m)',
    'propertyDetail.groundFloor': 'Ground floor',
    'propertyDetail.rentPrice': 'Rent price',
    'propertyDetail.rentIncome': 'Rent income',
    'propertyDetail.rentStarted': 'Rent started',
    'propertyDetail.rentEnd': 'Rent end',
    'propertyDetail.termOfannulment': 'Term of annulment',
    'propertyDetail.loadingDoor': 'Loading door',
    'propertyDetail.saleCommission': 'Sale commission (%)',
    'propertyDetail.saleCommission.exceedPercent': `Percent must not exceed 100%`,
    'propertyDetail.saleCommissionFixed': 'Sale commission (Fixed)',
    'propertyDetail.brokerageContract': 'Brokerage contracts',
    'propertyDetail.openContract': 'Open contract',
    'propertyDetail.exclusiveContract': 'Exclusive contract',
    'propertyDetail.featured': 'Featured',
    'propertyDetail.advertised': 'Advertised',
    'propertyDetail.listingDate': 'Listing date',
    'propertyDetail.listingExpireDate': 'Listing expire date',
    'propertyDetail.propertyStatus': 'Property status',
    'propertyDetail.error.selectAgent': 'Please select sale representative',
    'propertyDetail.archived': 'Archived',
    'propertyDetail.deleted': 'Delete',
    'propertyDetail.createLead': 'Create Lead',
    'propertyDetail.showLead': 'Show lead',
    'propertyDetail.convertToRent': 'Convert to Rent',
    'propertyDetail.convertToSale': 'Convert to Sale',
    'propertyDetail.convertToCommercial': 'Convert to Commercial',
    'propertyDetail.convertToResidential': 'Convert to Residential',
    'propertyDetail.duplicate': 'Duplicate',
    'propertyDetail.archive': 'Archive',
    'propertyDetail.unArchive': 'Unarchive',
    'propertyDetail.publishing': 'Publishing',
    'propertyDetail.inProgress': 'In progress',
    'propertyDetail.sureToArchive': 'Sure to archive?',
    'propertyDetail.video': 'Videos',
    'propertyDetail.blueprints': 'Blueprints',
    'propertyDetail.files': 'Files',
    'propertyDetail.sizeSqureMeter': 'Size (Sq.m)',
    'propertyDetail.error.valueExceedLength': 'Value exceed limit length.',
    'propertyDetail.error.limitLength': 'Value can be at most',
    'propertyDetail.error.character': 'characters',
    'propertyDetail.error.invalidEmail': 'Invalid email.',
    'propertyPicture.applyWatermarkSendingToWeb': 'Apply watermark when sending to web',
    'propertyDetail.pictureAndFiles': 'Pictures/Files',
    'propertyPicture.watermarkPosition': 'Watermark position',
    'propertyPicture.watermarkSetting': 'Watermark setting',
    'propertyPicture.previewWatermark': 'Preview watermark',
    'propertyPicture.useUserSetting': 'Use user setting (Default setting can be changed here)',
    'propertyPicture.useSpecificSetting': 'Use specific setting for only this property',
    'propertyPicture.topLeft': 'Top Left',
    'propertyPicture.topRight': 'Top Right',
    'propertyPicture.bottomLeft': 'Bottom Left',
    'propertyPicture.bottomRight': 'Bottom Right',
    'propertyPicture.center': 'Center',
    'propertyPicture.addVideo': 'Add video',
    'propertyPicture.url': 'URL',
    'propertyPicture.title': 'Title',
    'propertyPicture.pleaseInputUrl': 'Please input url.',
    'propertyDetail.convertTypeDescription': 'After a property has been converted, old property type will be lost. Please choose new property type and click Update to proceed',
    'propertyDetail.owners': 'Owners',
    'propertyPicture.ownerInformation': 'Owner information',
    'propertyPicture.renterInformation': 'Renter information',
    'propertyDetail.Loans': 'Loans',
    'propertyLoan.vr': 'V.R.',
    'propertyLoan.takeOver': 'Take over',
    'propertyLoan.mortgagee': 'Mortgagee',
    'propertyLoan.interest': 'Interest',
    'propertyLoan.originalAmount': 'Original Amount',
    'propertyLoan.loanRemainder': 'Loan Remainder',
    'propertyLoan.payment': 'Payment',
    'propertyLoan.remainingPayment': 'Remaining Payment',
    'propertyLoan.nextPaymentDue': 'Next payment due',
    'propertyLoan.notSendToWeb': 'Not send to web',
    'propertyLoan.summaryByMortgagee': 'Summary by mortgagee',
    'propertyLoan.summaryByLoanStatus': 'Summary by loan status',
    'propertyLoan.status': 'Status',
    'propertyLoan.amount': 'Amount',
    'propertyLoan.currency': 'Currency',
    'propertyLoan.exchangeRate': 'Exchange rate',
    'propertyLoan.originalCurrencyAmount': 'Original currency amount',
    'propertyLoan.interestRate': 'Interest rate',
    'propertyLoan.loanNumber': 'Loan number',
    'propertyLoan.pledge': 'Pledge',
    'propertyLoan.originalPayment': 'Original payment',
    'propertyLoan.baseIndex': 'Base index',
    'propertyLoan.index': 'Index',
    'propertyLoan.todayIndex': `Today's index`,
    'propertyLoan.typeOfLoan': 'Type of loan',
    'propertyLoan.correction': 'Correction',
    'propertyLoan.lockedRemainder': 'Locked remainder',
    'propertyLoan.paymentPerYear': 'Payment/Year',
    'propertyLoan.paymentCorrection': 'Payment correction',
    'propertyLoan.lockedPayment': 'Locked payment',
    'propertyLoan.startDate': 'Start date',
    'propertyLoan.realCost': 'Real cost',
    'propertyLoan.remark1': 'If nothing is input in required fields (red), automatic loan calculation will not work',
    'propertyLoan.remark2': 'Loan calculator uses the original payment amouths set by lender to calculate loan remainder and monthly payments. It can not reflect any changes from the original payment plan',
    'propertyLoan.validate.lessThan' : 'Remaining Payment must less than Original Payments',
    'propertyDetail.activityLog': 'Activities log',
    'propertyDetail.history': 'History',
    'propertyActivityLog.addActivity': 'Add activity',
    'propertyActivityLog.editActivity': 'Edit activity',
    'propertyHistory.sureToRestore': 'Confirm to restore this record'
};




// WEBPACK FOOTER //
// ./src/languageProvider/locales/en_US.ts